<template>
  <v-toolbar app color="primary">
    <v-toolbar-side-icon class="hidden-md-and-up white--text" @click="$emit('icon-click')"></v-toolbar-side-icon>
    <v-toolbar-title class="white--text app-title">{{title}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat icon class="white--text">
        <v-icon v-text="'notifications'"></v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style>
.app-title {
  font-size: 25px;
  line-height: 2;
}
</style>

